import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "submit", "message"]
  static values = { maxVotes: Number, weighted: Boolean }

  connect() {
    this.choiceOptions = this.selectTargets[0]
      ? Array.from(this.selectTargets[0].options).map((option) => ({ text: option.text, value: option.value }))
      : []
    this.validate()
  }

  validate() {
    this.syncChoices()

    const values = this.selectTargets.map((select) => select.value).filter((value) => value)
    let message = ""

    if (values.length > this.maxVotesValue) {
      message = `Choose no more than ${this.maxVotesValue} ${this.playerLabel(this.maxVotesValue)}.`
    } else if (values.length < this.maxVotesValue) {
      message = `Choose ${this.maxVotesValue} ${this.playerLabel(this.maxVotesValue)}.`
    } else if (this.weightedValue && new Set(values).size !== values.length) {
      message = "Choose each weighted vote only once."
    }

    this.messageTarget.textContent = message
    this.submitTarget.disabled = Boolean(message)
    this.submitTarget.classList.toggle("opacity-50", Boolean(message))
    this.submitTarget.classList.toggle("cursor-not-allowed", Boolean(message))
  }

  syncChoices() {
    if (!this.weightedValue) {
      this.selectTargets.forEach((select) => this.replaceOptions(select, this.choiceOptions, select.value))
      return
    }

    const selectedValues = this.selectTargets.map((select) => select.value)

    this.selectTargets.forEach((select, index) => {
      const currentValue = select.value
      const valuesUsedElsewhere = selectedValues.filter((value, selectedIndex) => value && selectedIndex !== index)
      const availableChoices = this.choiceOptions.filter((choice) => {
        return !choice.value || choice.value === currentValue || !valuesUsedElsewhere.includes(choice.value)
      })

      this.replaceOptions(select, availableChoices, currentValue)
    })
  }

  replaceOptions(select, choices, selectedValue) {
    select.replaceChildren(...choices.map((choice) => new Option(choice.text, choice.value, false, choice.value === selectedValue)))
  }

  playerLabel(count) {
    return count === 1 ? "player" : "players"
  }
}
